import React, { Fragment, useId } from 'react';
import { Link } from 'react-router-dom';
import { isNotNullOrUndefined, isNullOrUndefined } from '@utils/utils.tsx';
import { clickableTextClass } from '@components/RingilComponents/clickableText.ts';
import SvgChevron from '@icons/chevron-right.svg?react';
import clsx from 'clsx';
import SvgHomeFilled from '@icons/home-filled.svg?react';
import CustomTooltip from '@components/ringil3/Tooltip/CustomTooltip.tsx';
import useNavigation from '@hooks/useNavigation.tsx';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import RingilButton from '@components/ringil3/Buttons/RingilButton.tsx';

export interface BreadCrumbModel {
  label: string;
  disabled?: boolean | false;
  action: string | (() => void);
}

interface ComponentProps {
  model: BreadCrumbModel[];
}

const PageBreadCrumb: React.FC<ComponentProps> = ({ model }) => {
  const nav = useNavigation();
  const { tr } = useTranslationLgs();
  const homeId = `breadcrumb-home-${useId().replace(/:/g, '-')}`;
  return (
    <>
      <div className="flex gap-4 items-center text-sm">
        {/* Built through useNavigation so the language prefix and an active runAs survive the jump home. */}
        <Link id={homeId} to={nav.createNavigationLink({ pattern: '', queryParams: {}, applicationParams: {} })} className={clsx(clickableTextClass, 'flex items-center')}>
          <SvgHomeFilled className={'h-4 w-4 fill-current'} />
        </Link>
        <CustomTooltip targetSelector={`#${homeId}`} content={tr(`PageBreadCrumb.home`, `Home`)} />

        {model?.map((item, index, collection) => (
          <Fragment key={index}>
            <span className="text-black">
              <SvgChevron />
            </span>
            {isNotNullOrUndefined(item.action) && (
              <>
                {typeof item.action === 'string' && (
                  <Link to={item.action} className={clickableTextClass}>
                    {item.label}
                  </Link>
                )}
                {typeof item.action === 'function' && (
                  <RingilButton mode={'link'} onClick={item.action} label={item.label} className={'h-auto p-0 text-sm font-normal'} />
                )}
              </>
            )}
            {isNullOrUndefined(item.action) && <div className="text-zinc-600">{item.label}</div>}
          </Fragment>
        ))}
      </div>
    </>
  );
};

export default PageBreadCrumb;
